<div class="clear20"></div>
<div class="clear20"></div>
<div class="">
    <!-- <div class="col-sm-10 col-md-10 col-lg-10 col-xl-7 col-12 main-content"  *ngIf="isCompletedSA"> -->
        <div class="clear10"></div>
    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-7 col-12 main-content" *ngIf="isCompletedSA">
        
        <div class="card upload-card"  *ngFor="let item of contractDetails; let i=index">
            
            <div class="card-body">
                <div class="row">
                    <div class="col-7 col-sm-7 col-md-7 col-lg-7">
                        <h6 class="fs-18 txt-black regular">Sign Agreement</h6>
                    </div>
                    <div class="col-5 col-sm-5 col-md-5 col-lg-5">

                        <span *ngIf="item.status == 'Approved'" class="approved regular">Approved</span> 
                       
                        <div *ngIf="item.status == 'Not Approved' || item.status == ''">
                            <span class="disapproved regular"> <img src="./assets/images/disapprove.png">&nbsp;&nbsp;Not Approved</span>
                        </div>
                        <div *ngIf="item.status == 'Cancelled' ">
                            <span class="disapproved regular"> <img src="./assets/images/disapprove.png">&nbsp;&nbsp;Cancelled</span>
                        </div>
                        <!-- <div *ngIf="checkedDoc == 'Pending'"> -->
                        <!-- <span class="pending"> <img src="./assets/images/pending.png">&nbsp;&nbsp;APPROVAL PENDING</span> -->
                        <!-- </div> -->

                    </div>
                </div>

                <div class="clear10"></div>
                <div class="row">
                    <div  class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-12">
                        <!-- <img src="./assets/images/uploadfile.png" class="fiximg"> -->
                        <img *ngIf="item.fileUrl=='pdf'" src="./assets/images/pdf.png" class="fiximg">
                        <img *ngIf="item.fileUrl=='docx'|| item.fileUrl=='txt'" src="./assets/images/doc.png" class="fiximg">
                        <img *ngIf="item.fileUrl=='ms-excel' || item.fileUrl=='xlsx' || item.fileUrl=='xlsx' || item.fileUrl =='csv'|| item.fileUrl=='xls'" src="./assets/images/Excel.png" class="fiximg">
                        <img *ngIf="item.fileUrl=='png'|| item.fileUrl=='jpeg' || item.fileUrl=='jpg'" src="./assets/images/pngjpg.png" class="fiximg">
                        <div class="clear10"></div>
                        <button type="button" *ngIf="item.status=='Cancelled'" disabled class="btn  btn-link p-0"><u>Preview</u></button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button" *ngIf="item.status!='Cancelled'" (click)="onEoSelected()" class="btn  btn-link p-0"><u>Preview</u></button>&nbsp;&nbsp;&nbsp;&nbsp;

                        <p class="fs-14 regular txt-grey1" *ngIf="item.status == 'Not Approved' || item.status == ''">Reason:
                        </p>
                        <p class="fs-14 regular txt-grey1" *ngIf="item.status == 'Not Approved' || item.status == ''">Subreason:</p>
                        <!-- <p class="fs-14 regular txt-grey1">Policy Number: {{showPolicyNumber}}</p> -->
                        <p class="fs-14 regular txt-grey1" *ngIf="item.status == 'Not Approved' || item.status == ''">Description: </p>
                        <!-- <button *ngIf="!isUploaddoc && !isCompleted" type="button" class="btn pred btn-link p-0" (click)="removedocs()"><u>Remove</u></button> -->
                        <!-- <button [disabled]="checkedDoc == 'Pending' " *ngIf="checkedDoc == 'Pending' || checkedDoc == 'Not Approved'" type="button" class="btn pred btn-link p-0" (click)="removedocs()"><u>Remove</u></button> -->

                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">

                        <div class="clear20"></div>
                        <div class="clear20"></div>

                        <!-- <button type="button" class="btn btn-link p-0"><u>Preview</u></button>&nbsp;&nbsp;&nbsp;&nbsp; -->
                    </div>


                </div>
                <div class="clear10"></div>
                <!-- <div *ngIf="checkedDoc == 'Not Approved' || checkedDoc == ''"> -->

                <!-- </div> -->

            </div>
            
        </div>
        <div class="clear10"></div>


    </div>

    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
        <div class="">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10 col-12" *ngFor="let item of requestLicensarray;let i=index">
                <div class="addMoreLic" *ngIf="item.isRequestCompleted==false">
                    <div class="row">
                        <div class="col-8 col-sm-9 col-md-9 col-lg-9">
                            <label class="txt-red regular fs-16 semi-bold"><img class="mr-2" src="./assets/images/disapprove.png">License Requested</label>
                            <div class="fs-14 text46 italic"><span class="semi-bold">Message:</span> License Required. Please go to <span class="cp link" routerLink="/dashboard/upload-documents">“Upload Documents”</span> for more information.</div>
                        </div>
                        <!-- <div class="col-4 col-sm-3 col-md-3 col-lg-3 text-right">
                            <button type="button" class="btn btn-addLic" (click)="clickOnRequest(item.id)">+ Add New License</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10 col-12" *ngFor="let item of requestLicensarrayEO;let i=index">
                <div class="addMoreLic" *ngIf="item.isRequestCompleted==false">
                    <div class="row">
                        <div class="col-8 col-sm-9 col-md-9 col-lg-9">
                            <label class="txt-red regular fs-16 semi-bold"><img class="mr-2" src="./assets/images/disapprove.png">E&O Requested</label>
                            <div class="fs-14 text46 italic" routerLink="/upload-documents"><span class="semi-bold">Message:</span> E&O Required. Please go to <span class="cp link" routerLink="/dashboard/upload-documents">“Upload Documents”</span> for more information.</div>
                        </div>
                        <!-- <div class="col-4 col-sm-3 col-md-3 col-lg-3 text-right">
                            <button type="button" class="btn btn-addLic" (click)=" this.uploadLicensePopup = !this.uploadLicensePopup; clickOnRequest(item.id)">+ Add New License</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10 col-12" *ngFor="let item of requestLicensarrayVoidCheque;let i=index">
                <div class="addMoreLic" *ngIf="item.isRequestCompleted==false">
                    <div class="row">
                        <div class="col-8 col-sm-9 col-md-9 col-lg-9">
                            <label class="txt-red regular fs-16 semi-bold"><img class="mr-2" src="./assets/images/disapprove.png">Void Cheque Requested</label>
                            <div class="fs-14 text46 italic" routerLink="/upload-documents"><span class="semi-bold">Message:</span> Void Cheque Required. Please go to <span class="cp link" routerLink="/dashboard/upload-documents">“Upload Documents”</span> for more information.</div>
                        </div>
                        <!-- <div class="col-4 col-sm-3 col-md-3 col-lg-3 text-right">
                            <button type="button" class="btn btn-addLic" (click)=" this.uploadLicensePopup = !this.uploadLicensePopup; clickOnRequest(item.id)">+ Add New License</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="clear20"></div>
            <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10 col-12 p-0">
                <div *ngIf="signCard" class="main-content">
                    <div class="card cardbox" *ngIf="isInprogressUD">
                        <div class="card-body cp">
                            <h6 class="txt-black regular lh">You will be notified by email when a Travelance Sales Agreement is ready for you to review and sign.</h6>
                            <!-- <h6 class="txt-black regular lh">You’ll be able to sign the Agreement after the approval of your uploaded documents. Your Documents are successfully uploaded and are sent for reviewing. We’ll get back to you soon. Thank You for your patience.</h6> -->
                            <!-- <h6 class="txt-black regular lh">You’ll be able to <span class="bold">sign the Agreement</span> after the approval of your uploaded documents. Your Documents are successfully uploaded and are sent for reviewing. We’ll get back to you soon. Thank You for your patience.</h6> -->
                            <div class="clear20"></div>
                            <h6 class="txt-black regular">FOR ANY FURTHER ENQUIRIES MAIL US AT <a href="mailto:join@travelance.ca">join@travelance.ca </a></h6>
                        </div>
                    </div>
                    <div *ngIf="!isInprogressUD">
                        <!-- <h6 class="txt-black regular lh">You’ll be able to <span class="bold">see the Agreement</span> after the approval from Compliance Team. Thank You for your patience.</h6> -->
                        <h6 class="txt-black regular lh">You will be notified by email when a Travelance Sales Agreement is ready for you to review and sign.</h6>

                    </div>

                </div>

                <div *ngIf="!signCard">
                    <!-- <div> -->
                    <div class="card-body" class="main-content">
                        <h6 class="txt-black regular lh" [hidden]="!showbtn">A Travelance Sales Agreement is ready for you to review and sign. Click 'Sign Agreement' below to get started.</h6>
                        <!-- <h6 class="txt-black regular lh" [hidden]="isSignAgreement && !isCompleted || isSignAgreement && isCompleted">A Travelance Sales Agreement is ready for you to review and sign. Click “Sign Agreement” below to get started.</h6> -->
                        <div class="clear20"></div>
                        <button [ngClass]="!showbtn ?'editdisabled':''" [hidden]="!showbtn" type="button" class="fs-16 semi-bold text46 clickhere borsolid text-center box" (click)=" this.iframemodel = !this.iframemodel;" title="Please click here to Sign the Agreement">Sign Agreement</button>
                        <!-- <button [ngClass]="isSignAgreement && !isCompleted ?'editdisabled':''" [hidden]="isSignAgreement && !isCompleted || isSignAgreement && isCompleted" type="button" class="fs-16 semi-bold text46 clickhere borsolid text-center box" (click)=" this.iframemodel = !this.iframemodel;"
                            title="Please click here to Sign the Agreement">Sign Agreement</button> -->
                        <!-- <button  type="button" class="fs-16 semi-bold text46 clickhere borsolid text-center box" (click)="checkStatusSA()" title="Please click here to Sign the Agreement">Sign the Agreement</button> -->

                    </div>

                    <div *ngIf="signedStatus=='Signed' && !isCompletedSA" class="pl60">
                        <!-- <h6 class="txt-black regular lh">You’ll be able to <span class="bold">see the Agreement</span> after the approval from Compliance Team. Thank You for your patience.</h6> -->
                        <!-- <h6 class="txt-black regular lh">Your signed Agreement is sent for verification and counter sign. Once approved your on-boarding will be completed. Meanwhile you can take the Broker Online Training</h6> -->
                        <h6 class="txt-black regular lh">Thank you for submitting your signed agreement.</h6><br>
                        <h6 class="txt-black regular lh"> To complete the sign-up process,<span class="bold"> you must complete the required online training.</span>
                        </h6><br>
                        <h6 class="txt-black regular lh">Once you’ve completed the required online training and your agreement is approved, you will receive an email notifying you that the sign-up process is complete and you will be able to access our sales portal through MyTL. Please
                            allow up to 5 business days for your online sales portal to become active. If you have any questions, please email <a href="mailto:join@travelance.ca">join@travelance.ca</a>.
                        </h6>
                    </div>
                    <!-- 
                    <div *ngIf="isInprogressSA && isCompletedOT" class="pl60">
                        <h6 class="txt-black regular lh">Thank you for your submission. Your signed agreement is being reviewed. Once approved, you will receive an email notifying you that the sign-up process is complete and you will be able to access our online sales portal through
                            MyTL [link]. Please allow 5 business days. If you have any questions, please email <a href="join@travelance.ca">join@travelance.ca </a></h6>
                    </div> -->
                    <div class="clear20"></div>
                    <div class="card upload-card" *ngIf="signedStatus=='Signed' && !isCompletedSA && checkedDoc == 'More Information Required'">
                        <div class="card-body">
                            <div *ngIf="signedStatus=='Signed' && !isCompletedSA && checkedDoc == 'More Information Required'" class="">
                                <div class="row">
                                    <h3 class="fs-16 red regular">More Information is required: </h3>
                                    <div class="clear10"></div>
                                    <h4 class="fs-16 regular red"><span class="bold">&nbsp;'{{checkDocdesc}}'</span></h4>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="alert alert-black fixed-bottom ml-auto mb-0">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 text-right" *ngIf="signedStatus=='Signed' && !isCompletedSA">
                    <button type="button" class="btn btn-blue fntwt" routerLink="/dashboard/online-training">Proceed to Training<img src="./assets/images/btn-arrow.png" class="float-right" /></button>
                </div>
            </div>
        </div>

        <div id="iframemodel" class="modal" [style.display]="iframemodel ? 'block' : 'none'">
            <div class="modal-dialog iframe">
                <div class="modal-content">
                    <div class="row px-3 pt-3">
                        <div class="col-lg-10 col-sm-10 col-md-10 col-10">
                            <img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue regular fs-14"></label>
                        </div>
                        <div class="col-lg-2 col-sm-2 col-md-2 col-2">
                            <!-- <h6 class="close text-right" (click)=" this.iframemodel = !this.iframemodel;">&times;</h6> -->
                        </div>
                    </div>
                    <div class="modal-body ">
                        <div class="pdfarea">

                            <iframe *ngIf="!signCard" height="550px" width="100%" title="Agreement" frameBorder="0" [src]="urlSafe | sanitizePipe"></iframe>
                        </div>
                        <div class="clear20"></div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                                <!-- <button [ngClass]="isSignAgreement && isCompleted ?'editdisabled':''"  type="button" [disabled]="isSignAgreement && isCompleted" class=" fs-14 Regular addbtn mr-3" style="margin-left: 8px;"(click)=" this.iframemodel = !this.iframemodel;checkStatus()">Submit</button> -->
                                <button [ngClass]="isSignAgreement && isCompleted ?'editdisabled':''" type="button" [disabled]="isSignAgreement && isCompleted" class="fs-14 regular cancalbtn cp" (click)="submitLeadAgreement()">Close</button>
                            </div>
                            <div class="clear10"></div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="clear20"></div>
        </div>
    </div>
</div>
<div id="deleteLeadsPopup" class="modal" [style.display]="deleteLeadsPopup ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-md">
        <div class="modal-content w-100">
            <div class="modal-header">
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center">
                    <span class="fs-20 semi-bold text46 ">Please Confirm</span>
                </div>
                <!-- <h6 class="close text-right" (click)=" this.deleteLeadsPopup = !this.deleteLeadsPopup;">&times;</h6> -->
            </div>
            <div class="modal-body p-0 m-0">
                <div class="clear20"></div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center">
                    <p class="fs-16 regular text46">Are you sure you want to cancel?</p>
                    <div class="clear40"></div>
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-center">
                            <button type="button" class=" fs-14 semi-bold cancalbtn text46" (click)=" this.deleteLeadsPopup = !this.deleteLeadsPopup;">No</button>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-center">
                            <button type="button" class=" fs-14 semi-bold addbtn" (click)="closePopup()">Yes</button>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>

<div id="deletemdl" class="modal" [style.display]="deleteModal ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content w-100">
            <div class="modal-header">
                <h6 class="close text-right cp" (click)=" this.deleteModal = !this.deleteModal;">&times;</h6>
            </div>
            <div class="modal-body p-0 m-0">
                <!-- <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center"> -->
                <iframe [src]='Url | sanitizePipe' height="475px" width="100%" title="Iframe Example" style="border: none" allowtransparency="true" frameBorder="0" seamless="seamless"></iframe>
                <!-- </div> -->
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>